import { useState, useEffect, useMemo } from "react";
import {
  TextField,
  Grid,
  Container,
  CssBaseline,
  Typography,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';
import Button from '../../components/button';
import { useStyles } from "../Login/styles";
import { axiosHelper } from "utils/axios";
import { useHistory, useLocation } from "react-router";
import { SignupProps } from "./types";

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}


const Signup = ({ isClinician, isPatient }: SignupProps) => {
  const classes = useStyles();
  const query = useQuery();
  const history = useHistory();

  const [formState, setFormState] = useState({
    organization: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false,
    regToken: query.get('regToken'),
    phone: null,
    fax: null
  });
  const [errorState, setErrorState] = useState('');
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);

  const scrollUp = () => {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    scrollUp();
  }, []);

  const onSubmit = (e: any) => {
    e.preventDefault();
    setErrorState('');
    setLoading(true);
    let route;
    if (isClinician && formState.regToken) {
      route = 'register-clinician'
    }
    else if (isPatient && formState.regToken) {
      route = 'register-patient'
    }
    else {
      route = 'register-client'
    }

    axiosHelper.post(`/Users/${route}`, formState).then(() => {
      scrollUp();
      if (formState.regToken) {
        history.push('/login?creation=sucesss');
      } else {
        setComplete(true);
      }
    }).catch((error) => {
      scrollUp();
      const errors = error.response.data.errors;
      const keys = Object.keys(errors);
      setErrorState(errors[keys[0]]);
      setLoading(false);
    });
  }

  return (
    <Container component="main" className={classes.loginWrapper}>
      <CssBaseline />
      {complete ?
        <Grid xs={4} className={classes.accountCreatedWrapper}>
          <Grid className={classes.verificationMessage}>
            <Typography component="h1" variant="h5" className={classes.accountCreatedHeader}>
              Account Created
            </Typography>
            <Typography component="p" className={classes.accountCreatedText}>
              Please check your email to verify!
            </Typography>
          </Grid>
        </Grid>
        :
        <Grid xs={4} className={classes.paper}>
          <Typography component="h1" variant="h5" className={classes.header}>
            Sign Up
          </Typography>
          <form className={classes.form} noValidate onSubmit={onSubmit}>
            {errorState ? <span>{errorState}</span> : null}
            {formState.regToken ? null : <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="organization"
              label="Organization Name"
              placeholder="Enter Organization"
              name="organization"
              value={formState.organization}
              onChange={(e) => { setFormState({ ...formState, organization: e.target.value.trim() }) }}
            />}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="firstName"
              label="First Name"
              name="firstName"
              value={formState.firstName}
              onChange={(e) => { setFormState({ ...formState, firstName: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="lastName"
              label="Last Name"
              name="lastName"
              value={formState.lastName}
              onChange={(e) => { setFormState({ ...formState, lastName: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="emailAddress"
              label="Email Address"
              name="email"
              autoComplete="emailAddress"
              value={formState.email}
              onChange={(e) => { setFormState({ ...formState, email: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              value={formState.password}
              autoComplete="current-password"
              onChange={(e) => { setFormState({ ...formState, password: e.target.value.trim() }) }}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="verifyPassword"
              label="Confirm Password"
              type="password"
              id="verifypassword"
              value={formState.confirmPassword}
              autoComplete="current-password"
              onChange={(e) => { setFormState({ ...formState, confirmPassword: e.target.value.trim() }) }}
            />
            <FormControlLabel
              classes={{ label: classes.checkboxLabel }}
              control={<Checkbox
                checked={formState.acceptTerms}
                onChange={(event) => setFormState({ ...formState, acceptTerms: event.target.checked })}
                name="AcceptTerms"
                color="primary"
              />}
              label={'By creating an account, you acknowledge our Terms of Use'}
            />
            <Button
              text={'Sign Up'}
              version={'secondary'}
              type='submit'
              isDisabled={loading}
              action={() => { }}
              styles={{
                width: "100%",
                justifyContent: 'center',
                marginTop: 15
              }}
            />
          </form>
        </Grid>}
    </Container>
  );
}

export default Signup